import { showImgDomain } from "@/config/apiDomain";
import { Ref, computed, ref, watch } from "vue";

const isPc = 1200;
const viewWidth: Ref<number> = ref<number>(document.body.offsetWidth);

const isPad = computed(() => viewWidth.value < 1200);
const isMobile = computed(() => viewWidth.value < 680);

const showAside: Ref<boolean> = ref<boolean>(false);

const clickBodyNum: Ref<number> = ref<number>(0);
const sendNum: Ref<number> = ref<number>(0);

const triggerFocus: Ref<boolean> = ref<boolean>(false);

const isOfficial: Ref<boolean> = ref<boolean>(false);
const isTest: Ref<boolean> = ref<boolean>(false);

const imgDomain = showImgDomain;

const needVip = false;

const isCompactMode = ref(isMobile.value);

export {
  needVip,
  isPc,
  isPad,
  isMobile,
  showAside,
  viewWidth,
  clickBodyNum,
  sendNum,
  triggerFocus,
  isOfficial,
  isTest,
  imgDomain,
  isCompactMode,
};
